<button mat-button
        type="button"
        skip-disable
        disableRipple="true"
        class="ui-expandable-iconbutton"
        [disabled]="parent.isAnimating"
        (click)="parent.toggleFullHeight()">
  <mat-icon>{{parent.isFullHeight ? 'fullscreen_exit' : 'fullscreen'}}</mat-icon>
</button>
